export default "__VITE_ASSET__8366784c__"